import React, { useEffect } from 'react';
import { Popover } from 'antd';
import { Helmet } from 'react-helmet';
import { getTranslated } from 'utils';
import Translated from 'components/Translated';
import Locale from 'components/Locale';
import Form from './Form';
import Machine from './Machine';
import { StyledLocale } from './Login.styled';

const Login = ({
    admin,
    locale,
    loadReseller,
    reseller,
    userData,
}) => {
    useEffect(() => {
        const { hostname } = window.location;
        loadReseller(process.env.REACT_APP_ENVIRONMENT === 'prod' ? hostname.replace('.front', '') : hostname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const resellerName = reseller.data ? reseller.data.hits[0]?.name : null;

    return (
        <section className="gx-app-login-wrap">
            <Helmet>
                <title>{getTranslated('global.home', locale)} | {resellerName || ''}</title>
                <link id="favicon" rel="shortcut icon" href={`${process.env.REACT_APP_CDN}admin/favicon/${admin}.ico`} />
            </Helmet>

            <div className="gx-app-login-container">
                <aside className="gx-language">
                    <Popover
                        overlayClassName="gx-popover-horizantal"
                        placement="bottomRight"
                        content={<Locale />}
                        trigger="click"
                    >
                        <StyledLocale className="gx-pointer gx-flex-row gx-align-items-center">
                            <i className="la la-language la-lg" />
                            <span className="gx-language"><Translated id={`locale.${locale}`} /></span>
                            <i className="la la-angle-down la-lg gx-pl-2" />
                        </StyledLocale>
                    </Popover>
                </aside>
                <div className="gx-app-login-main-content">
                    <aside className="gx-app-logo-content">
                        <div className="gx-app-logo-content-bg" />

                        <div className="gx-app-logo-wid">
                            <h1 className="gx-fs-xxxl">
                                { userData.operator?.machine === null ? (
                                    <>
                                        <small className="gx-fs-sm"><Translated id="global.hello" />,</small><br />
                                        <span>{userData.data.first_name}</span>
                                    </>
                                ) : <Translated id="global.login" />}
                            </h1>
                        </div>
                        <div className="gx-app-logo">
                            <img src={`${process.env.REACT_APP_CDN}admin/logos/${admin}.png`} alt="" />
                        </div>
                    </aside>
                    <div className="gx-app-login-content">
                        { userData.operator?.machine === null ? <Machine /> : <Form />}
                        <span className="gx-text-light gx-fs-sm">Copyright &copy; {new Date().getFullYear()}. {resellerName}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Login;
